module.exports = __webpack_public_path__ + "img/himo-logo.bf2181e9.png";